import type { ClientStatus } from "../types/database";
import { clientService } from "../services/clientService";
import { useAsyncData } from "./useAsyncData";

export function useClients(input: {
  tenantId?: string | null;
  search?: string;
  status?: ClientStatus | "all";
}) {
  return useAsyncData(
    () =>
      input.tenantId
        ? clientService.listClients({
            tenantId: input.tenantId,
            search: input.search,
            status: input.status,
          })
        : Promise.reject(new Error("No workspace selected.")),
    [input.tenantId, input.search, input.status],
  );
}
